<template>
  <div>
    <div class="subnavbackground">
      <SavedSearches 
        application="tv-analys" 
        :tabName="$route.meta.tabQuery" 
        :currentFilters="$store.getters[`get${$route.meta.tabQuery}Query`]"
        :isExpanded="expandSavedSearchesSidebar"
        @close="$store.commit('setExpandSavedSearchesSidebar', false)"
      />
      <b-row v-if="obsMessage" class="obs-message-row">
        <p class="obsText">{{ obsMessage }}</p>
      </b-row>
      <b-row class="bottomheader mr-0">
        <!-- Left content -->
        <div class="d-flex align-items-center info-tooltip-container">
          <div class="this-tool-container">
            <div id="versionTooltip" class="this-tool-icon-container">
              <img class="this-tool-icon" :src="blueAppIconPath" alt="" />
            </div>
            <span v-if="userInternalText()" class="userinternaltext">
              {{ userInternalText() }} &#x1F441;
            </span>
          </div>
          <b-tooltip
            v-if="
              SSASMessage != null || this.config_CurrentClientVersion != null
            "
            target="versionTooltip"
            boundary="viewport"
            html
            triggers="hover"
            custom-class="infoTooltip"
          >
            <p>Client version: {{ this.config_CurrentClientVersion }}</p>
            <p>API version: {{ SSASMessage.version }}</p>
            <p>Model: {{ SSASMessage.linkedSSAS }}</p>
            <p>Last SSAS processing: {{ SSASMessage.lastProcessed }}</p>
            <p>Last panel day: {{ SSASMessage.latestDay }}</p>
            <p>First publish date: {{ SSASMessage.publishedFromDate }}</p>
            <p>Last publish date: {{ SSASMessage.publishedToDate }}</p>
            <p>Last ad log data: {{ SSASMessage.metadataAdToDate }}</p>
            <p>
              Last program log data: {{ SSASMessage.metadataProgramToDate }}
            </p>
            <p>
              Streaming published:
              {{ SSASMessage.streamingPublishedFromDate }}-{{
                SSASMessage.streamingPublishedToDate
              }}
            </p>
          </b-tooltip>
        </div>
        <!-- Center content -->
        <div
          v-if="$store.getters.getCurrentApp !== 'video-in-home'"
          class="center-container"
        >
          <div class="absolute-center">
            <router-link
              v-if="
                this.$store.state.systemInfo.lightAccess ||
                  this.$store.state.systemInfo.fullAccess
              "
              to="/toplist"
              >Top list</router-link
            >
            <router-link
              v-if="this.$store.state.systemInfo.fullAccess"
              to="/programs"
              >Program</router-link
            >
            <router-link
              v-if="
                this.$store.state.systemInfo.fullAccess ||
                  this.$store.state.systemInfo.advertiserAccess
              "
              to="/campaigns"
              >Ad</router-link
            >
            <router-link
              v-if="this.$store.state.systemInfo.fullAccess"
              to="/channels"
              >Channel</router-link
            >
          </div>
        </div>
        <!-- Right content -->
        <div>
          <div class="d-flex right-content right" v-if="showButton()">
            <b-button 
              class="btn-xs" 
              variant="primary" 
              id="tooltip-target-1" 
              @click="$store.commit('setExpandSavedSearchesSidebar', true)" 
              v-if="showSaveSearchButton"
            >
              <i class="bi bi-floppy"></i>
            </b-button>
            <b-tooltip target="tooltip-target-1" triggers="hover">
              Save/load template
            </b-tooltip>
            <b-button
              class="btn-xs mx-2"
              variant="primary"
              @click="handleToggleInformationSidebarClick"
              id="infoButton"
            >
              <b-icon icon="info-circle"></b-icon>
            </b-button>
            <b-tooltip
              target="infoButton"
              triggers="hover"
              placement="top"
            >
              View information log
            </b-tooltip>

            <b-button
              @click="openManual"
              class="btn-xs"
              variant="info"
              id="bookButton"
            >
              <b-icon icon="book"></b-icon>
              <span></span>
            </b-button>
            <b-tooltip target="bookButton" triggers="hover" placement="top">
              Read user manual
            </b-tooltip>
          </div>
        </div>
      </b-row>
    </div>
    <b-sidebar
      right
      id="info-sidebar"
      title="Information log"
      shadow
    >
      <div class="px-3 py-2">
        <p class="messageBox" v-html="dataLogMessage"></p>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import globalConfig from "@/mixins/globalConfig";
import SavedSearches from "./SavedSearches"; 
import { dateToyymmddFormat, dateToTimeStamp } from "../../../api/utils.js";
import { fetchFormFieldData } from "../../../api/api.js";
import videoInHomeBlueIcon from '@/assets/images/video-in-home-blue.svg';
import tvBlueIcon from '@/assets/images/tv-blue.svg';
export default {
  name: "SubNav",
  components: {
    SavedSearches
  },
  mixins: [globalConfig],
  data() {
    return {
      lightAccess: false,
      fullAccess: false,
      messageCache: {},
      applicationHeading: "",
      applicationSubHeading: "",
      obsMessage: "",
      dataLogMessage: "",
      SSASMessage: {
        linkedSSAS: "",
        version: "",
        lastProcessed: "",
        latestDay: "",
        publishedFromDate: "",
        publishedToDate: "",
        metadataAdToDate: "",
        metadataProgramToDate: "",
        streamingPublishedFromDate: "",
        streamingPublishedToDate: ""
      }
    };
  },
  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let token = urlParams.get("token");
    let user = urlParams.get("user");

    if (token === null) {
      token = localStorage.getItem("accessToken", token);
      user = localStorage.getItem("user", user);
    }

    localStorage.setItem("accessToken", token);
    localStorage.setItem("user", user);

    this.$store.commit("setLoggedIn", true);
    this.$store.commit("setUser", user);
    this.$store.commit("setAccessToken", token);
    try {
      const messages = await fetchFormFieldData("Message");
      if (messages.statusCode) {
        this.toastMessage(messages.errorMessage, false);
      } else {
        this.messageCache = messages;
        this.setMessageByTab();
      }
    } catch (error) {
      if (error.response?.status != 401)
        this.toastMessage(
          "Problem uppstod vid hämtning av meddelanden.",
          false
        );
      console.error(error);
    }

    //Fetch Version from api
    await fetchFormFieldData("Information")
      .then(information => {
        if (information.statusCode) {
          this.toastMessage(information.errorMessage, false);
        } else {
          this.SSASMessage.linkedSSAS = information.linkedSSAS;
          this.SSASMessage.version = information.version;
          this.SSASMessage.lastProcessed =
            dateToyymmddFormat(information.lastProcessed.replace(/-/g, "/")) +
            " " +
            dateToTimeStamp(information.lastProcessed.replace(/-/g, "/"));
          this.SSASMessage.latestDay = dateToyymmddFormat(
            information.latestDay.replace(/-/g, "/")
          );
          this.SSASMessage.publishedFromDate = dateToyymmddFormat(
            information.publishedFromDate.replace(/-/g, "/")
          );
          this.SSASMessage.publishedToDate = dateToyymmddFormat(
            information.publishedToDate.replace(/-/g, "/")
          );
          this.SSASMessage.metadataAdToDate = dateToyymmddFormat(
            information.metadataAdToDate.replace(/-/g, "/")
          );
          this.SSASMessage.metadataProgramToDate = dateToyymmddFormat(
            information.metadataProgramToDate.replace(/-/g, "/")
          );

          this.SSASMessage.streamingPublishedFromDate = dateToyymmddFormat(
            information.streamingPublishedFromDate.replace(/-/g, "/")
          );

          this.SSASMessage.streamingPublishedToDate = dateToyymmddFormat(
            information.streamingPublishedToDate.replace(/-/g, "/")
          );

          this.$store.commit(
            "setMetadataAdToDate",
            this.SSASMessage.metadataAdToDate
          );

          this.$store.commit(
            "setExcelExportFilePreName",
            information.excelExportFilePreName
          );
          this.$store.commit(
            "setExcelExportTextInFile",
            information.excelExportTextInFile
          );
          this.$store.commit(
            "setMetadataProgramToDate",
            this.SSASMessage.metadataProgramToDate
          );
          this.$store.commit(
            "setPublishedFromDate",
            this.SSASMessage.publishedFromDate
          );
          this.$store.commit(
            "setPublishedToDate",
            this.SSASMessage.publishedToDate
          );
          this.$store.commit(
            "setStreamingPublishedFromDate",
            this.SSASMessage.streamingPublishedFromDate
          );
          this.$store.commit(
            "setStreamingPublishedToDate",
            this.SSASMessage.streamingPublishedToDate
          );
          this.$store.commit("setLatestDay", this.SSASMessage.latestDay);
        }
      })
      .catch(error => {
        if (error.response?.status != 401)
          this.toastMessage(
            "Problem att hämta standarddatum från servern. Tjänsten kommer inte fungera korrekt.",
            true
          );
        console.error(error);
      });
      document.addEventListener("keyup", this.onKeyUp);
  },
  async mounted() {
    await this.loadGlobalConfigFromFile();
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.onKeyUp);
  },
  computed: {
    expandSavedSearchesSidebar: {
      get() {
        return this.$store.getters.getExpandSavedSearchesSidebar;
      },
      set(value) {
        this.$store.commit('setExpandSavedSearchesSidebar', value);
      }
    },
    showSaveSearchButton() {
      return this.$store.getters.getShowSaveSearchButton;
    },
    blueAppIconPath() {
      return this.$route.name === "VideoInHome"
        ? videoInHomeBlueIcon
        : tvBlueIcon;
    }
  },
  watch: {
    $route() {
      this.$store.commit('setExpandSavedSearchesSidebar', false);
      this.$route.meta.tabQuery === "Toplist" ? this.$store.commit('setShowSaveSearchButton', false) : this.$store.commit('setShowSaveSearchButton', true);
      this.setMessageByTab();
    }
  },
  methods: {
    userInternalText() {
      let userInternalText = "";
      if (this.$store.state.systemInfo.internalAndMMSOnly)
        userInternalText = "MMS-ONLY";
      return userInternalText;
    },
    setMessageByTab() {
      if (this.$route.name == "VideoInHome") {
        // visa information för Video in home
        this.obsMessage = this.messageCache.streamingObsMessage;

        this.dataLogMessage = this.messageCache.streamingDataLogMessage;
      } else { 
        // annars visa information för BROADCAST
        this.obsMessage = this.messageCache.obsMessage;
        this.dataLogMessage = this.messageCache.dataLogMessage;
      }
    },
    showButton() {
      if (
        this.$route.path == "/" &&
        this.$store.getters.getCurrentApp !== 'video-in-home'
      ) {
        return false;
      }
      return true;
    },
    handleToggleInformationSidebarClick() {
      this.setMessageByTab();
      this.$root.$emit("bv::toggle::collapse", "info-sidebar");
    },
    openManual() {
      let manualLink = "https://mms.se/wp-content/uploads/manual-tv-analys-topplista.pdf";
      
      if (this.$store.getters.getCurrentApp === 'video-in-home') {
        manualLink = "https://mms.se/wp-content/uploads/manual_video_in_home.pdf";
      } else if (
        this.$store.state.systemInfo.fullAccess ||
        this.$store.state.systemInfo.advertiserAccess
      ) {
        manualLink = "https://mms.se/wp-content/uploads/manual-tv-analys.pdf";
      }
      
      window.open(manualLink, "_blank");
    },
    toastMessage(message, closeButton, variant = "warning", title = "Warning") {
      if (closeButton) {
        const h = this.$createElement;

        const vNodesMsg = h("b", { class: ["text-center", "mb-0"] }, [
          "Problem fetching default date from the server. The service will not function correctly.",
          h(
            "b-button",
            {
              class: ["float-right", "btn-sm", "mr-3"],
              on: {
                click: () => this.$bvToast.hide("toast")
              }
            },
            "Close"
          )
        ]);

        this.$bvToast.toast([vNodesMsg], {
          id: "toast",
          title: title,
          variant: variant,
          solid: true,
          noCloseButton: true,
          autoHideDelay: 300000
        });
      } else {
        this.$bvToast.toast(message, {
          title: title,
          variant: variant,
          solid: true,
          noCloseButton: false
        });
      }
    }
  }
};
</script>

<style scoped>
>>> .b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-right: 3rem;
}
>>> .userinternaltext {
  color: red;
}
a {
  text-transform: uppercase;
  margin: 5px 20px;
  position: relative;
  display: inline-block;
  color: #337ab7;
}
.router-link-exact-active {
  font-weight: bold;
}
.subnavbackground {
  height: auto;
}
.messageBox {
  border: 1px solid #dee2e6 !important;
  background-color: #eee;
  margin-bottom: 0;
  padding: 10px;
  font-size: small;
  color: #2c3e50 !important;
  text-align: left;
  white-space: pre-line;
}
.bottomheader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border-bottom: #aaa 1px dotted;
  height: 40px !important;
  padding: 5px 16px;
  position: relative;
  flex-wrap: wrap;
}
.center-container {
  margin-top: 4px;
}
.absolute-center {
  position: absolute;
  width: 750px !important;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 10;
}
.this-tool-container {
  position: relative;
  padding: 0;
  margin-right: 3rem;
  align-self: center;
  display: inline-block;
  align-content: center;
}
.this-tool-icon-container {
  display: inline-block;
  flex: 1;
  height: 100%;
  width: 2.4rem;
  margin-top: 0;
  margin-left: 1rem;
  max-width: 2.5rem;
  max-height: 2.5rem;
}
img.this-tool-icon {
  max-width: 1.5rem;
  max-height: 1.5rem;
  margin-left: 0.2rem;
  margin-right: 0.4rem;
  padding: 0;
}
.right {
  position: absolute;
  right: 10px;
  margin-top: -14px;
}
.informationlogtext {
  font-size: 0.8em;
}

::v-deep .tooltip-inner {
  max-width: none !important;
  font-size: smaller;
  text-align: left;
}

.right-content {
  margin-right: 35px;
}
.btn-xs {
  padding: 5px 10px;
  margin-top: -1px;
  height: 30px;
  line-height: 0.5;
  border-radius: 0.2rem;
  font-size: 18px;
}
.btn-xs .b-icon {
  margin-top: -2px;
}

.obs-message-row {
  margin-right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 0 16px;
  flex-grow: 1;
  background-color: white;
  border-bottom: 1px solid #225380;
  flex-wrap: nowrap;
}
.obsText {
  margin-left: 18px;
  margin-bottom: 0;
  padding: 5px 0;
  letter-spacing: 0.25px;
  color: #ff8c00;
  font-size: 0.9em;
  flex-grow: 1;
  overflow-wrap: break-word;
}

@media (max-width: 1000px) {
  .absolute-center {
    width: 60vw !important;
  }
  .bottomheader {
    height: 60px !important;
  }
}
</style>
